import type { TextMarker } from '@/shared/lib';
import { STORED_TIMECODE_PATTERN } from '../lib/commentTimecodes';

/** Ссылка на правило в тексте комментария. */
export type RuleMarker = { type: 'rule'; id: number; text: string };

/** Ссылка на узел знаний в тексте комментария. */
export type KnowledgeNodeMarker = { type: 'knowledgeNode'; id: number };

/** Таймкод фрагмента записи в тексте комментария. */
export type TimeFragmentMarker = { type: 'fragment'; time: string };

/** Служебный маркер в тексте комментария к оценке. */
export type CommentMarker = RuleMarker | KnowledgeNodeMarker | TimeFragmentMarker;

/** Ссылка на правило: `[ruleId: 12|Название правила]`. */
const RULE_MARKER: TextMarker<RuleMarker> = {
  pattern: /\[ruleId:\s*(\d+)\|([^\]]+)\]/,
  parse: (match) => ({ type: 'rule', id: Number(match[1]), text: match[2] }),
};

/** Ссылка на узел знаний: `[knowledgeNodeId: 7]`. */
const KNOWLEDGE_NODE_MARKER: TextMarker<KnowledgeNodeMarker> = {
  pattern: /\[knowledgeNodeId:\s*(\d+)\]/,
  parse: (match) => ({ type: 'knowledgeNode', id: Number(match[1]) }),
};

/** Собирает ссылку на узел знаний для вставки в текст комментария. */
export const buildKnowledgeNodeMarker = (nodeId: number): string => `[knowledgeNodeId:${nodeId}]`;

/** Таймкод фрагмента записи: `[12:34]` или `[1:23:45]`. */
const TIME_FRAGMENT_MARKER: TextMarker<TimeFragmentMarker> = {
  pattern: STORED_TIMECODE_PATTERN,
  parse: (match) => ({ type: 'fragment', time: match[1] }),
};

/** Маркеры комментария к оценке: ссылки на правила, узлы знаний и таймкоды. */
export const EVALUATION_COMMENT_MARKERS: TextMarker<CommentMarker>[] = [
  RULE_MARKER,
  KNOWLEDGE_NODE_MARKER,
  TIME_FRAGMENT_MARKER,
];

/** Маркеры комментария к атрибуту: только таймкоды. */
export const ATTR_COMMENT_MARKERS: TextMarker<TimeFragmentMarker>[] = [TIME_FRAGMENT_MARKER];
